import { Button, ButtonGroup, Menu, MenuItem, SxProps } from "@mui/material";
import { FC, ReactNode, useRef, useState } from "react";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";

type Props = {
	title?: ReactNode;
	icon?: ReactNode;
	disabled?: boolean;
	sx?: SxProps;
	actions: Array<{
		title: ReactNode;
		action: () => void;
	}>;
};

export const ButtonMenu: FC<Props> = ({
	title = "",
	icon,
	sx,
	disabled = false,
	actions,
}) => {
	const [open, setOpen] = useState(false);
	const anchorElRef = useRef<HTMLDivElement>(null);
	return (
		<>
			<ButtonGroup
				disabled={disabled}
				variant="contained"
				onClick={() => {
					if (disabled) return;
					setOpen(!open);
				}}
				ref={anchorElRef}
			>
				<Button aria-label="open dropdown menu" startIcon={icon} sx={sx}>
					{title}
				</Button>
				<Button
					aria-label="open dropdown menu"
					size="small"
					sx={{ minWidth: 0, padding: 0 }}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Menu
				anchorEl={anchorElRef.current}
				open={open}
				onClose={() => setOpen(false)}
			>
				{actions.map(({ title, action }, i) => (
					<MenuItem
						key={i}
						onClick={() => {
							action();
							setOpen(false);
						}}
					>
						{title}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};
